export const reducerTypes = {
  TOGGLE_ALERT: 'reducer/TOGGLE_ALERT',
  CLOSE_ALERT: 'reducer/CLOSE_ALERT',
};

export type AlertType = {
  active: boolean;
  text: string;
  isPrompt?: boolean;
  header?: string;
  noIcon?: boolean;
  onApprove?: () => void;
  delay?: number;
  onDecline?: () => void;
  description?: string;
  errorType?: boolean;
};
